import React, { useState, useEffect } from "react"
import ProductCard from "../molecules/ProductCard"
import Seo from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Seo"

import { InstantSearch, Configure, connectHits } from "react-instantsearch-dom"
import algoliasearch from "algoliasearch/lite"
import useMediaQuery from "../../hooks/useMediaQuery"
import SwitchToggle from "../molecules/SwitchToggle"
import { decode } from "html-entities"
import { Disclosure } from "@headlessui/react"
import { ChevronDown16 } from "@carbon/icons-react"
import { useTranslation } from "react-i18next"

const Hits = connectHits(({ hits }) => {
  return (
    <>
      {hits.map((hit) => (
        <div
          title={hit.name}
          className="flex w-full mb-8 px-grid md:w-1/2 lg:w-1/3"
          key={hit.objectID}
        >
          {console.log(hit)}
          <ProductCard
            item={{
              isNewToggle: hit.isNewFlag,
              isNewFromDate: hit.isNewStart,
              isNewUntilDate: hit.isNewEnd,
              headline: hit.name,
              description: hit.productDescription,
              image: hit.image_url,
              link: hit.full_slug,
            }}
          />
        </div>
      ))}
    </>
  )
})

const ProductFinderBlock = ({
  entry,
  products,
  scope,
  sb_metadata,
  area = null,
}) => {
  const { t } = useTranslation()
  /* console.log(products) */
  const [filtered, setFiltered] = useState(false)
  const [filters, setFilters] = useState(
    `website:"${entry.language}" AND type:"product" AND ${scope}:${entry.ID}`
  )
  let isDesktop = useMediaQuery(`(min-width: 672px)`)

  const searchClient = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_SEARCH_KEY
  )

  let containerTypeData = []
  let applicationFiltersData = []
  let technicalFiltersData = []

  products.forEach((product) => {
    const applicationFilters = product.node.filterableApplicationAreas.map(
      (a) => decode(a)
    )
    applicationFilters && applicationFiltersData.push(applicationFilters)

    const technicalFilters = product.node.filterableTechnicalData
    //filters && console.log(filters)
    technicalFilters && technicalFiltersData.push(technicalFilters)

    containerTypeData.push(product.node.productContainerType.value)
  })

  containerTypeData = [...new Set(containerTypeData)]

  const hasContainerFilter = containerTypeData.length > 1

  const applicationFilters = [
    ...new Set([
      ...applicationFiltersData
        .flat()
        .map((a) => a.value)
        .flat(),
    ]),
  ]
  const technicalFilters = [...new Set([...technicalFiltersData.flat()])]

  const technicalFiltersReduced = technicalFilters.reduce((acc, curr) => {
    if (acc.some((a) => a.originId === curr.originId)) {
      acc.find((a) => a.originId === curr.originId).values.push(curr.value)
    } else {
      acc.push({
        label: curr.label,
        originId: curr.originId,
        values: [curr.value],
      })
    }
    return acc
  }, [])

  const technicalFiltersUnique = technicalFiltersReduced.map((f) => {
    return {
      label: f.label,
      originId: f.originId,
      values: [...new Set(f.values)],
    }
  })

  const handleFilters = (type, value) => {
    if (filters.includes(` AND ${type}:"${value}`)) {
      setFilters(filters.replace(` AND ${type}:"${value}"`, ""))
    } else {
      setFilters(`${filters} AND ${type}:"${value}"`)
      setFiltered(true)
    }
  }

  useEffect(() => {
    if (
      filters ===
      `website:"${entry.language}" AND type:"product" AND ${scope}:${entry.ID}`
    ) {
      setFiltered(false)
    }
  }, [filters, entry])

  useEffect(() => {
    return () => {
      setFilters(
        `website:"${entry.language}" AND type:"product" AND ${scope}:${entry.ID}`
      )
      setFiltered(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <InstantSearch
      indexName={process.env.GATSBY_ALGOLIA_INDEX_NAME}
      searchClient={searchClient}
    >
      <Configure filters={filters} hitsPerPage={400} />
      {scope === "area" && (
        <Seo
          content={{ metadata: sb_metadata }}
          title={`${entry.name} | ${t("generic.meta.products")}`}
          no_description_fallback={
            sb_metadata?.description?.length > 0 ? false : true
          }
          language={entry.language}
        />
      )}
      {scope === "group" && (
        <Seo
          content={{ metadata: sb_metadata }}
          title={`${entry.name} | ${t("generic.meta.products")}`}
          description={`${entry.name} | ${area.name}`}
          language={entry.language}
        />
      )}
      <section className="py-block">
        <div className=" block-w-container">
          <div className="flex flex-row flex-wrap -mx-grid">
            <div className="w-full mb-16 md:w-1/3 lg:w-1/4 px-grid">
              {(hasContainerFilter === true ||
                applicationFilters.length > 0 ||
                technicalFiltersUnique.length > 0) && (
                <>
                  <h2 className="mb-4 text-xl uppercase">
                    {t("generic.product_finder.title")}
                  </h2>
                  {containerTypeData.map((contType) => {
                    return (
                      <SwitchToggle
                        key={`container-type-${contType}`}
                        label={t(
                          "generic.product_finder.container_type_" + contType
                        )}
                        onChange={() =>
                          handleFilters("container_type", contType)
                        }
                      />
                    )
                  })}
                </>
              )}

              {applicationFilters.length > 0 && (
                <Disclosure defaultOpen={isDesktop}>
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex justify-between w-full py-2 mt-10 text-left border-b-2 border-primary">
                        <span className={`${open ? "text-primary" : ""}`}>
                          {t("generic.tabs.application_areas")}
                        </span>
                        <ChevronDown16
                          className={`${
                            open ? "rotate-180 transform text-primary" : ""
                          } h-5 w-5 `}
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="pt-4 pb-2 text-sm">
                        {applicationFilters.sort().map((a, index) => {
                          return (
                            <SwitchToggle
                              key={`application-${index}`}
                              label={a}
                              onChange={() => handleFilters("application", a)}
                            />
                          )
                        })}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              )}
              {technicalFiltersUnique.length > 0 && (
                <Disclosure defaultOpen={isDesktop}>
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex justify-between w-full py-2 mt-10 text-left border-b-2 border-primary">
                        <span className={`${open ? "text-primary" : ""}`}>
                          {t("generic.tabs.technical_data")}
                        </span>
                        <ChevronDown16
                          className={`${
                            open ? "rotate-180 transform text-primary" : ""
                          } h-5 w-5`}
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="pt-4 pb-2 text-sm">
                        {technicalFiltersUnique.map((a, index) => {
                          return (
                            <Disclosure key={`disclosures-additional-${index}`}>
                              {({ open }) => (
                                <>
                                  <Disclosure.Button className="flex justify-between w-full py-4 text-left border-b border-gray-100">
                                    <span data-product-attr-id={a.originId}>
                                      {a.label}
                                    </span>
                                    <ChevronDown16
                                      className={`${
                                        open ? "rotate-180 transform" : ""
                                      } h-5 w-5 `}
                                    />
                                  </Disclosure.Button>
                                  <Disclosure.Panel className="pt-4 pb-6 mb-4 text-sm border-b border-gray-100">
                                    {a.values.sort().map((a, innerindex) => {
                                      return (
                                        <SwitchToggle
                                          key={`additional-${innerindex}`}
                                          label={a}
                                          onChange={() =>
                                            handleFilters("filters", a)
                                          }
                                        />
                                      )
                                    })}
                                  </Disclosure.Panel>
                                </>
                              )}
                            </Disclosure>
                          )
                        })}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              )}
            </div>
            <div className="w-full md:w-2/3 lg:w-3/4 px-grid">
              <div className="flex flex-row flex-wrap -mx-grid">
                {!filtered ? (
                  products.map((product) => {
                    return (
                      <div
                        title={product.node.ID}
                        className="flex w-full mb-8 px-grid md:w-1/2 lg:w-1/3"
                        key={product.node.ID}
                      >
                        <ProductCard
                          item={{
                            headline: product.node.displayName?.value,
                            isNewToggle: product.node.isNewToggle.value,
                            isNewFromDate: product.node.isNewFromDate?.value,
                            isNewUntilDate: product.node.isNewUntilDate?.value,
                            image: product.node.mainImage?.items[0]
                              ? product.node.mainImage?.items[0].value
                              : null,
                            description: product.node.productDescription?.value,
                            variants: "8",
                            link:
                              product.node.variantFullSlug ||
                              product.node.fullSlug,
                          }}
                        />
                      </div>
                    )
                  })
                ) : (
                  <Hits />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </InstantSearch>
  )
}

export default ProductFinderBlock
